__turbopack_context__.v({
  "activeReset": "categorie-item-styling-module-scss-module__JqYsLq__activeReset",
  "catItemActive": "categorie-item-styling-module-scss-module__JqYsLq__catItemActive",
  "catItemContainer": "categorie-item-styling-module-scss-module__JqYsLq__catItemContainer",
  "catItemNotActive": "categorie-item-styling-module-scss-module__JqYsLq__catItemNotActive",
  "isChild": "categorie-item-styling-module-scss-module__JqYsLq__isChild",
});
